module.exports = __webpack_public_path__ + "img/solution12.6768882a.png";